import { HttpClient } from 'modules/http-client'
import { ForFeatureFnReturn } from 'modules/module-loader'
import { WebStorage } from 'modules/web-storage'

import { RouterService } from '../core'
import { AuthService } from './auth.service'
import { epics, reducers, STORE_ID } from './store'

export interface Providers {
  authService: AuthService
}

interface Injectables {
  httpClient: HttpClient
  routerService: RouterService
  webStorage: WebStorage
}

export class AuthModule {
  static forRoot({ httpClient, routerService, webStorage }: Injectables): ForFeatureFnReturn<Providers> {
    const authService = new AuthService(httpClient, routerService, webStorage)

    const providers = {
      authService,
    }

    return {
      providers,
      store: {
        id: STORE_ID,
        reducers,
      },
      epics,
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts